import { render, staticRenderFns } from "./occurrenceGrid.vue?vue&type=template&id=2f23e83e&scoped=true&"
import script from "./occurrenceGrid.vue?vue&type=script&lang=js&"
export * from "./occurrenceGrid.vue?vue&type=script&lang=js&"
import style0 from "./occurrenceGrid.vue?vue&type=style&index=0&id=2f23e83e&prod&lang=css&"
import style1 from "./occurrenceGrid.vue?vue&type=style&index=1&id=2f23e83e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23e83e",
  null
  
)

export default component.exports